module.exports = "/images/vendor/flag-icon-css/flags/4x3/pk.svg?c2e1a15939a23c5894eb4af1f20e3e73";